import React, { useState } from 'react';
import Icons from '../components/Icons';
import { CTASection } from '../components/Sections';
import FooterSection from '../components/Footer';

const FAQPage = ({ isDark }) => {
  const faqs = [
    {
      question: 'What documents do I need to rent a car?',
      answer: 'You need a valid driving license (minimum 1 year old), Aadhar card or passport for identity proof, and a valid mobile number.'
    },
    {
      question: 'Is there a minimum rental period?',
      answer: 'Yes, the minimum rental period is 24 hours (1 day). We also offer hourly rentals for select vehicles within Udaipur city.'
    },
    {
      question: 'What is your cancellation policy?',
      answer: 'Free cancellation up to 24 hours before pickup. 50% charge for cancellations between 24-12 hours. No refund for cancellations less than 12 hours.'
    },
    
    {
      question: 'Are your cars insured?',
      answer: 'Yes, all our vehicles are fully insured with comprehensive coverage including third-party insurance.'
    },
    {
      question: 'Can I extend my rental period?',
      answer: 'Yes! You can extend your rental by contacting us at least 1 hours before your scheduled return time, subject to availability.'
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'We accept cash, all major credit/debit cards, UPI payments, and net banking.'
    },
    {
      question: 'Is there a security deposit?',
      answer: 'Yes, a refundable security deposit is required which varies based on the car category. Fully refundable within 24 hours.'
    },
    {
      question: 'Do you provide driver services?',
      answer: 'We primarily offer self-drive rentals. However, we can arrange a driver at an additional cost upon request.'
    },
    {
      question: 'What happens in case of breakdown?',
      answer: 'We provide 24/7 roadside assistance. In case of breakdown, we will arrange for a replacement vehicle.'
    }
  ];

  const [openIndex, setOpenIndex] = useState(0);

  return (
    <>
      <section className={`relative py-10 sm:py-16 md:py-24 transition-colors duration-300 ${isDark ? 'bg-[#0a0a0a]' : 'bg-gray-900'}`}>
        <div className={`absolute inset-0 ${isDark ? 'bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a]' : 'bg-gradient-to-b from-gray-800 to-gray-900'}`}></div>
        <div className="relative z-10 container-custom text-center px-4">
          <h1 className="text-xl sm:text-2xl md:text-4xl lg:text-5xl font-bold mb-1 sm:mb-2 md:mb-4 text-white">Frequently Asked <span className="text-[#c9a962]">Questions</span></h1>
          <p className="text-xs sm:text-sm md:text-base lg:text-lg text-gray-400">Find answers to all your questions</p>
        </div>
      </section>
      <section className={`py-6 sm:py-10 md:py-16 transition-colors duration-300 ${isDark ? 'bg-[#0d0d0d]' : 'bg-gray-100'}`}>
        <div className="container-custom px-3 sm:px-4">
          <div className="max-w-3xl mx-auto">
            {faqs.map((faq, index) => (
              <div 
                key={index}
                className={`mb-1.5 sm:mb-2 md:mb-3 rounded-md sm:rounded-lg md:rounded-xl overflow-hidden transition-all duration-300 ${isDark ? 'bg-[#1a1a1a]' : 'bg-white shadow'}`}
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                  className={`w-full px-3 sm:px-4 md:px-5 py-2.5 sm:py-3 md:py-4 text-left flex items-center justify-between transition-colors ${isDark ? 'hover:bg-[#252525]' : 'hover:bg-gray-50'}`}
                >
                  <span className={`font-medium text-xs sm:text-sm md:text-base ${isDark ? 'text-white' : 'text-gray-900'}`}>{faq.question}</span>
                  <span className={`transform transition-transform duration-300 flex-shrink-0 ml-2 w-3 h-3 sm:w-4 sm:h-4 ${openIndex === index ? 'rotate-180' : ''} text-[#c9a962]`}>
                    <Icons.ChevronDown />
                  </span>
                </button>
                <div 
                  className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-32 opacity-100' : 'max-h-0 opacity-0'}`}
                >
                  <p className={`px-3 sm:px-4 md:px-5 pb-2.5 sm:pb-3 md:pb-4 leading-relaxed text-[11px] sm:text-xs md:text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <CTASection isDark={isDark} />
      <FooterSection isDark={isDark} />
    </>
  );
};

export default FAQPage;
